export default "__VITE_ASSET__d1ad65e9__"